// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Share } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconShare(props: any) {
    return <IconBase icon={Share} {...props} />
  }

  export default IconShare
  